var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center justify-center"},[_c('v-img',{style:(_vm.content.dsc_midia_tipo === 'backstage-video' ? 'border-radius: var(--sc-radius-xl);' : ''),attrs:{"src":_vm.content.url_thumbnail}}),_c('span',{staticClass:"mt-2 ml-1 align-self-start"},[_vm._v(" "+_vm._s(this.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }